export const rrc = {
    agencyCode: '455',
    name: 'Railroad Commission of Texas',
    shortName: 'RRC',
    slug: 'rrc',
  };